var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBListEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-order-new",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-order-new1",
    serifid: "iconB-order-new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,13c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l8,0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-8,0Zm-0,-6c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l12,0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-12,0Zm-0,12c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l5,0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-5,0Zm15.592,-13.789c0.89,-1.334 2.692,-1.694 4.026,-0.805c1.333,0.889 1.694,2.691 0.805,4.025l-7.044,10.564c-0.212,0.319 -0.326,0.472 -0.459,0.603c-0.15,0.149 -0.319,0.277 -0.503,0.379c-0.163,0.092 -0.342,0.159 -0.706,0.275l-2.207,0.702c-0.284,0.09 -0.592,0.047 -0.84,-0.119c-0.248,-0.165 -0.407,-0.434 -0.433,-0.729l-0.2,-2.307c-0.034,-0.382 -0.04,-0.572 -0.018,-0.758c0.024,-0.209 0.077,-0.415 0.156,-0.61c0.07,-0.173 0.167,-0.337 0.38,-0.656l7.043,-10.564Zm1.057,5.348l-1.57,-1.046l-4.899,7.348c-0.101,0.153 -0.161,0.223 -0.194,0.306l-0.001,0.003c-0.013,0.031 -0.022,0.064 -0.026,0.097c-0.01,0.089 0.008,0.18 0.024,0.362c0,-0 0.094,1.086 0.094,1.086l1.039,-0.33c0.174,-0.056 0.265,-0.074 0.343,-0.118c0.03,-0.017 0.058,-0.037 0.082,-0.061c0.063,-0.063 0.106,-0.146 0.208,-0.298l4.9,-7.349Zm-0.483,-2.677l1.57,1.047l1.056,-1.585c0.289,-0.433 0.172,-1.019 -0.261,-1.308c-0.434,-0.289 -1.019,-0.172 -1.308,0.262l-1.057,1.584Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBListEdit);
export default __webpack_public_path__ + "static/media/iconB-list-edit.34e0f2a12045ea81849700cee1f57a68.svg";
export { ForwardRef as ReactComponent };